<style lang="scss"></style>

<template>
  <div id="modal-remove-material" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="material">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de material
                    <span
                      class="text-info"
                    >{{ material.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoMaterialService from '../../../services/TipoMaterialService';

export default {
  name: 'modal-remove-material',
  data() {
    return {
      enviando: false,
      material: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-material').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeMaterialId = null;
    });

    if (this.$parent.removeMaterialId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.material = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeMaterialId === 0) return;

        this.material = await TipoMaterialService.findById(
          this.$parent.removeMaterialId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-material').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoMaterialService.remove(this.material.id);

        this.$toast.success('Tipo de material removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-material').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
